// extracted by mini-css-extract-plugin
export var card = "_s7-0";
export var details = "_s7-1";